export default __webpack_public_path__ + "static/N0318-1e7030effb8e336d3807fba2a9f7ee02.png";